// const isFacebookApp = () => {
//   let ua = navigator.userAgent || navigator.vendor || window.opera;
//   return (ua.indexOf("FBAN") > -1) || (ua.indexOf("FBAV") > -1);
// }

export default {
  monthlyPrice () {
    if (this.priceObject && this.priceObject.bookingDays >= 61) {
      return Math.round(this.rentalPrice / this.priceObject.bookingDays * 30)
    }
    return null
  },

  rentalPrice () {
    return parseInt((this.useMinPeriodPrice
      ? this.priceObject.bookingMinPeriodPrice
      : this.priceObject.bookingPrice) * 100) / 100
  },

  useMinPeriodPrice () {
    return this.priceObject.minDays > this.priceObject.bookingDays
  },
}
